"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnterpriseDepartmentCode_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var EnterpriseDepartmentCode_Factory = /** @class */ (function () {
    function EnterpriseDepartmentCode_Factory() {
    }
    EnterpriseDepartmentCode_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            DepartmentCodeId: model.DepartmentCodeId,
            ServiceCode: model.ServiceCode,
            ServiceName: model.ServiceName,
        };
        return result;
    };
    EnterpriseDepartmentCode_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            DepartmentCodeId: model.DepartmentCodeId,
            ServiceCode: model.ServiceCode,
            ServiceName: model.ServiceName,
        };
        return result;
    };
    return EnterpriseDepartmentCode_Factory;
}());
exports.EnterpriseDepartmentCode_Factory = EnterpriseDepartmentCode_Factory;
